import { createRuntime, type LindezaRuntime } from '@lindeza/core';
import { DexieStorage } from '@lindeza/storage-web';
import { toast } from './ui';

/** Origem da API ("" = mesma origem, via proxy em dev e nginx em produção). */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL ?? '';
/** Origem dos links enviados às clientes. */
export const PUBLIC_BASE_URL: string = import.meta.env.VITE_PUBLIC_URL || window.location.origin;

function deviceName(): string {
  const ua = navigator.userAgent;
  if (/iPhone|iPad/.test(ua)) return 'iPhone';
  if (/Android/.test(ua)) return 'Android';
  if (/Mac/.test(ua)) return 'Mac';
  if (/Windows/.test(ua)) return 'Windows';
  return 'Navegador';
}

export function buildRuntime(): LindezaRuntime {
  return createRuntime({
    storage: new DexieStorage(),
    fetch: (input, init) => fetch(input, init as RequestInit),
    apiBaseUrl: API_BASE_URL,
    publicBaseUrl: PUBLIC_BASE_URL,
    deviceName: deviceName(),
    onInvalidRecord: (entity, record, issues) => console.warn('[lindeza] registro inválido do servidor', entity, record, issues),
    onRemoteChanges: (_entities, counts) => {
      if (counts.appointmentsFromLink > 0) {
        toast(
          counts.appointmentsFromLink === 1
            ? 'Novo agendamento pelo link!'
            : `${counts.appointmentsFromLink} novos agendamentos pelo link!`,
        );
      }
    },
  });
}
